import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<GroupManageEmailSettings @group={{this.model}} />",{ moduleName: "discourse/templates/group/manage/email.hbs" })